export const LAYOUT = {
  X2: 'op-versus-2',
  X4: 'op-versus-4',
  VS: 'op-versus',
  DEFAULT: 'op-default'
}

export const LOGGED_STATUS = {
  LOGGED: "logged",
  NOTLOGGED: "notlogged"
}